import type * as FirebaseAuth from "firebase/auth"
import type { UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api } from "../../core"
import { UploadToFireStorageInput } from "../UploadToFireStorageInput"
import { FirebaseStoragePaths } from "popopo-msg"

type UserProfileIconForms = {
  image: boolean
}

export const UserProfileIconForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const form = useForm<UserProfileIconForms>({
    mode: "onBlur",
    defaultValues: {
      image: false,
    },
  })

  const onSubmit = async (value: UserProfileIconForms) => {
    if (!value.image) {
      return
    }

    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT("/api/v2/users/me/profile/icon", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  const image = form.watch("image")
  const { isSubmitting, isValid } = form.formState

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <UploadToFireStorageInput
          label="Image"
          uploadPath={`/${FirebaseStoragePaths.User.getIconPathUploaded(props.firebase.uid)}`}
          onChange={(successfullyUploaded) => form.setValue("image", successfullyUploaded)}
          disabled={isSubmitting}
        />

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !image || !isValid}>
          Upload
        </button>
      </form>
    </>
  )
}
